import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Clock, AlertCircle, Shield } from 'lucide-react';

export default function PendingAccountBanner() {
  const { user } = useAuth();

  if (!user || user.status !== 'pending') {
    return null;
  }

  return (
    <div className="bg-amber-500/10 border border-amber-500/30 rounded-2xl p-6 mb-6" data-testid="pending-account-banner">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-amber-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
          <Clock className="w-6 h-6 text-amber-400" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-amber-400 mb-2">
            Conta em Análise
          </h3>
          <p className="text-slate-300 text-sm mb-4">
            A sua conta está em processo de verificação. Assim que os seus dados forem validados, 
            receberá um email de confirmação e poderá começar a investir.
          </p>
          <div className="flex flex-wrap gap-4 text-sm">
            <div className="flex items-center gap-2 text-slate-400">
              <Shield className="w-4 h-4" />
              <span>Verificação de identidade</span>
            </div>
            <div className="flex items-center gap-2 text-slate-400">
              <AlertCircle className="w-4 h-4" />
              <span>Prazo: 24-48 horas</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function RestrictedAction({ children, message = "Esta funcionalidade estará disponível após a aprovação da sua conta." }) {
  const { user } = useAuth();

  if (!user || user.status !== 'pending') {
    return children;
  }

  return (
    <div className="relative">
      <div className="opacity-50 pointer-events-none">
        {children}
      </div>
      <div className="absolute inset-0 bg-[#1D262D]/80 backdrop-blur-sm rounded-xl flex items-center justify-center">
        <div className="text-center p-6 max-w-sm">
          <Clock className="w-12 h-12 text-amber-400 mx-auto mb-4" />
          <p className="text-white font-medium mb-2">Conta Pendente</p>
          <p className="text-slate-400 text-sm">{message}</p>
        </div>
      </div>
    </div>
  );
}
